import * as actionTypes from '../consts/actionTypes';

const initialState = {
    products: [],
    productsAdmin: [],
    postProducts: null,
    postProductsIGEN: null,
    putProducts: null,
    product: null,
    productByCategory: null,
    productBySubcategory: null,
    createImage: null,
    getSearcherProducts: null,
    putProductChangeStatus: null,
    getSearcherProductsAdmin: null,
    loading: null,
    error: null
};

export default function productReducer(state = initialState, action) {
    const DEFAULT = { ...state };
    const ACTIONS = {
        [actionTypes.SHOW_LOADING]: showLoading(),
        [actionTypes.CLEAR_REQUEST_FAILURE]: clearReducer('CLEAR_REQUEST_FAILURE', 'error'),
        [actionTypes.SUCCESS_GET_PRODUCTS]: responseToReturn('products'),
        [actionTypes.CLEAR_PRODUCTS]: clearReducer('CLEAR_PRODUCTS', 'products'),
        [actionTypes.SUCCESS_GET_PRODUCTS_ADMIN]: responseToReturn('productsAdmin'),
        [actionTypes.SUCCESS_POST_PRODUCTS]: responseToReturn('postProducts'),
        [actionTypes.SUCCESS_POST_PRODUCTS_IGEN]: responseToReturn('postProductsIGEN'),
        [actionTypes.SUCCESS_PUT_PRODUCTS]: responseToReturn('putProducts'),
        [actionTypes.SUCCESS_GET_PRODUCT_ID]: responseToReturn('product'),
        [actionTypes.SUCCESS_GET_PRODUCTS_BY_CATEGORY]: responseToReturn('productByCategory'),
        [actionTypes.SUCCESS_GET_PRODUCTS_BY_SUBCATEGORY]: responseToReturn('productBySubcategory'),
        [actionTypes.SUCCESS_GET_SEARCHER_PRODUCTS]: responseToReturn('getSearcherProducts'),
        [actionTypes.CLEAR_SEARCHER_PRODUCTS]: clearReducer('CLEAR_SEARCHER_PRODUCTS', 'getSearcherProducts'),
        [actionTypes.SUCCESS_POST_CREATE_IMAGE]: responseToReturn('createImage'),
        [actionTypes.SUCCESS_PUT_PRODUCT_CHANGE_STATUS]: responseToReturn('putProductChangeStatus'),
        [actionTypes.CLEAR_POST_PRODUCT]: clearReducer('CLEAR_POST_PRODUCT', 'postProductsIGEN'),
        [actionTypes.CLEAR_PUT_PRODUCT]: clearReducer('CLEAR_PUT_PRODUCT', 'putProducts'),
        [actionTypes.SUCCESS_GET_SEARCHER_PRODUCTS_ADMIN]: responseToReturn('getSearcherProductsAdmin'),
        [actionTypes.ERROR_PRODUCT]: errorReturn('error'), //REVISARRRRRRRRR! errorReturn
    }

    function responseToReturn(typeState) {
        let res = { ...state };
        if (action.response
            && action.type !== 'SUCCESS_PUT_PRODUCT_CHANGE_STATUS'
            && action.type !== 'ERROR_PRODUCT'
            && action.type !== 'CLEAR_REQUEST_FAILURE') {
            res = { ...state, [typeState]: action.response.data, loading: false };
        }
        if (action.type === 'SUCCESS_PUT_PRODUCT_CHANGE_STATUS'
            && action.type !== 'ERROR_PRODUCT'
            && action.type !== 'CLEAR_REQUEST_FAILURE') {
            res = { ...state, [typeState]: action.response.data };
        }
        if (action.type === 'SUCCESS_GET_PRODUCTS') {
            res = { ...state, [typeState]: action.response.data, product: null };
        }
        return res;
    }

    function showLoading() {
        if (action.type === 'SHOW_LOADING') {
            return { ...state, loading: action.payload };
        }
        return state;
    }

    function errorReturn(typeState) {
        if (action.response && action.type === 'ERROR_PRODUCT') {
            return { ...state, [typeState]: action.response };
        }
        return state;
    }

    function clearReducer(typeConst, typeState) {
        if (action.type === typeConst) {
            return { ...state, [typeState]: null };
        }
        return state;
    }

    let receiveAction = DEFAULT;

    if (ACTIONS[action.type] !== undefined) {
        receiveAction = ACTIONS[action.type];
    }

    return receiveAction;
}